import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-melvin-louise',
  templateUrl: './melvin-louise.component.html',
  styleUrls: ['./melvin-louise.component.scss']
})
export class MelvinLouiseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
